import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-data-view',
  imports: [CommonModule],
  templateUrl: './fzunterklasse.list-view.html',
  styleUrls: ['./fzunterklasse.list-view.scss'],
})
export class FzunterklasseListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
